import {css} from 'lit';
export const styles = css`:host {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  min-height: 20px;
  padding: 3px 7px;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  font-family: var(--font-family);
  white-space: nowrap;
  border-radius: 10px;
}

:host([theme='primary']) {
  background-color: var(--primary);
}

:host([theme='secondary']) {
  background-color: var(--secondary);
}

:host([theme='success']) {
  background-color: var(--success);
}

:host([theme='danger']) {
  background-color: var(--danger);
}

:host([theme='warning']) {
  background-color: var(--warning);
}

:host([theme='info']) {
  background-color: var(--info);
}

:host([count='0']) {
  background-color: var(--dark-bg-secondary);
}
`;
export default styles;
